import api from "./api";
import type {
  IAvaliacaoPedidoListResponse,
  IAvaliacaoProdutoListResponse,
  IAvaliacoesListParams,
  StatusAvaliacao,
} from "interfaces/loja";

function buildQuery(params?: IAvaliacoesListParams): string {
  const sp = new URLSearchParams();
  if (!params) return "";
  if (params.page != null) sp.set("page", String(params.page));
  if (params.pageSize != null) sp.set("pageSize", String(params.pageSize));
  if (params.status) sp.set("status", params.status);
  if (params.q?.trim()) sp.set("q", params.q.trim());
  const s = sp.toString();
  return s ? `?${s}` : "";
}

/**
 * GET /loja/avaliacoes/produtos — painel (roles)
 */
export async function getAllAvaliacoes(params?: IAvaliacoesListParams) {
  try {
    const qs = buildQuery(params);
    const { data, status } = await api.get<IAvaliacaoProdutoListResponse>(
      `/loja/avaliacoes/produtos${qs}`
    );
    return { data, status } as {
      data: IAvaliacaoProdutoListResponse;
      status: number;
    };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * GET /loja/avaliacoes/pedidos — painel (roles)
 */
export async function getAllAvaliacoesPedidos(params?: IAvaliacoesListParams) {
  try {
    const qs = buildQuery(params);
    const { data, status } = await api.get<IAvaliacaoPedidoListResponse>(
      `/loja/avaliacoes/pedidos${qs}`
    );
    return { data, status } as {
      data: IAvaliacaoPedidoListResponse;
      status: number;
    };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function updateStatusAvaliacaoProduto(
  avaliacaoId: string,
  statusNovo: StatusAvaliacao
) {
  try {
    const { data, status } = await api.put(
      `/loja/avaliacoes/produtos/${avaliacaoId}/status`,
      {
        status: statusNovo,
      }
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function updateStatusAvaliacaoPedido(
  avaliacaoId: string,
  statusNovo: StatusAvaliacao
) {
  try {
    const { data, status } = await api.put(
      `/loja/avaliacoes/pedidos/${avaliacaoId}/status`,
      {
        status: statusNovo,
      }
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
